import {
  makeStyles,
  makeResetStyles,
  shorthands,
  tokens,
} from '@fluentui/react-components';

export const usePromptEditorStyles = makeStyles({
  selectedButton: {
    backgroundColor: '#F0EEEE',
    ...shorthands.border('1px', 'solid', tokens.colorStrokeFocus2),
  },
  toggleButton: {
    backgroundColor: '#FAFAFA',
  },
  textareaPlaceHolder: {
    width: '100%',
    backgroundColor: 'transparent',
    boxShadow: '0px 0px 2px 0px rgba(23, 26, 31, 0.12), 0px 0px 1px 0px rgba(23, 26, 31, 0.07)',
    '& textarea': {
      color: '#8F8F8F',
      fontSize: '24px',
      fontWeight: '400',
      lineHeight: '36px',
    },
  },
  textarea: {
    width: '100%',
    boxShadow: '0px 0px 2px 0px rgba(23, 26, 31, 0.12), 0px 0px 1px 0px rgba(23, 26, 31, 0.07)',
    backgroundColor: 'transparent',
    '& textarea': {
      color: '#000',
      fontSize: '24px',
      fontWeight: '600',
      lineHeight: '32px',
    },
  },
  autoCompleteTextarea: {
    position: 'absolute',
    backgroundColor: '#FAFAFA',
    width: '100%',
    '& textarea': {
      color: '#999',
      fontSize: '24px',
      fontWeight: '600',
      lineHeight: '32px',
    },
  },
});

export const usePromptEditorBaseStyles = makeResetStyles({
  width: '100%',
  '& .prompt': {
    ...shorthands.borderRadius('8px', '8px', '0px', '0px'),
    ...shorthands.borderBottom('none'),
    clipPath: 'inset(-2px -2px 0 -2px)',
    borderBottomStyle: 'none',
    '&:hover, &:active, &:focus, &:focus-within': {
      borderBottomStyle: 'none',
    },
    '::after': {
      display: 'none',
    },
    height: 'calc(38% - 70px)',
    minHeight: '348px',
    paddingTop: '12px',
    '& textarea': {
      maxHeight: 'unset',
      height: 'unset',
    },
  },
  '& .words, .buttons': {
    backgroundColor: '#FAFAFA',
    width: '100%',
  },
  '& .words': {
    ...shorthands.borderLeft('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderRight('1px', 'solid', tokens.colorNeutralStroke1),
    boxShadow: '0px 0px 2px 0px rgba(23, 26, 31, 0.12), 0px 0px 1px 0px rgba(23, 26, 31, 0.07)',
    clipPath: 'inset(0px -2px 0px -2px)',
    paddingLeft: '12px',
    paddingBottom: '20px',
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    flexWrap: 'wrap',
    borderTopStyle: 'none',
    '& button': {
      height: '32px',
      ...shorthands.borderRadius('8px', '8px', '8px', '8px'),
      ...shorthands.border('1px', 'solid', '#B0BEFF'),
      backgroundColor: '#FAFAFA',
      fontWeight: tokens.fontWeightRegular,
      '&:hover': {
        backgroundColor: tokens.colorNeutralBackground1Hover,
        borderColor: tokens.colorStrokeFocus2,
        borderWidth: '1px',
        borderStyle: 'solid',
      },
      minWidth: 'unset',
      whiteSpace: 'nowrap',
    },
  },
  '& .buttons': {
    ...shorthands.borderRadius('8px', '8px', '8px', '8px'),
    ...shorthands.borderTop('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderLeft('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderBottom('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderRight('1px', 'solid', tokens.colorNeutralStroke1),
    boxShadow: '0px 0px 2px 0px rgba(23, 26, 31, 0.12), 0px 0px 1px 0px rgba(23, 26, 31, 0.07)',
    position: 'relative',
    top: '-8px',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: '12px 12px',
    ...shorthands.gap('12px'),
    overflowX: 'hidden',
    '& button': {
      fontWeight: tokens.fontWeightRegular,
      height: '32.1px',
      ...shorthands.borderRadius('8px', '8px', '8px', '8px'),
      '&:hover': {
        backgroundColor: tokens.colorNeutralBackground1Hover,
        borderColor: tokens.colorStrokeFocus2,
        borderWidth: '1px',
        borderStyle: 'solid',
      },
      minWidth: 'unset',
      whiteSpace: 'nowrap',
    },
  },
});
